<template>
  <a-modal :title="title" :visible="visible" @ok="handleOk" @cancel="handleCancel" :confirmLoading="confirmLoading">
    <a-form layout="vertical">
      <a-form-item :label="$t('备注信息')">
        <a-textarea v-model="comment" :placeholder="$t('请输入备注信息')" :autoSize="{ minRows: 3, maxRows: 6 }" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'TakeOrderModal',
  data() {
    return {
      title: '',
      successMsg: '',
      visible: false,
      confirmLoading: false,
      comment: '',
      record: null,
      url: {
        pass: '', // 从父组件传入
      },
    }
  },
  methods: {
    showModal(record, url, type) {
      this.visible = true
      this.record = record
      this.url.pass = url.pass
      if (type == '接单') {
        this.title = this.$t('接单确认')
        this.successMsg = this.$t('接单成功')
      } else if (type == '驳回') {
        this.title = this.$t('驳回确认')
        this.successMsg = this.$t('已驳回')
        this.url.pass = url.reject
      } else {
        this.title = this.$t('归档确认')
        this.successMsg = this.$t('归档成功')
      }
      this.comment = ''
    },
    handleOk() {
      this.confirmLoading = true

      let params = {
        dataId: this.record.id,
        values: {
          dataId: this.record.id,
        },
        comment: this.comment,
      }
      this.$http
        .post(this.url.pass, params)
        .then(res => {
          if (res.success) {
            this.$message.success(this.successMsg)
            this.$emit('success')
            this.visible = false
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
